import Vue from 'vue'
import axios from 'axios'
import qs from "qs"

// 在common.js文件中统一存放一些公共常量，方便之后维护
import './common.js'
import router from '../../router'

// // 添加请求拦截器，在发送请求之前做些什么(**具体查看axios文档**)--------------------------------------------
// axios.interceptors.request.use(function (config) {
//   // 显示loading
//
//   // 在请求发送之前做一些处理
//   const token = localStorage.token; // util.cookies.get('token');
//   // 让每个请求携带token-- ['Authorization']为自定义key 请根据实际情况自行修改
//   config.headers['Authorization'] = token;
//   // if(config.data.ContentType!=null){
//   //   config.headers['Content-Type'] = 'application/json';
//   // }
//
//   return config
// }, function (error) {
//   // 请求错误时弹框提示，或做些其他事
//   return Promise.reject(error)
// })

function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}
//
// // 添加响应拦截器(**具体查看axios文档**)----------------------------------------------------------------
// axios.interceptors.response.use(function (response) {
//   console.log('response',response);
//   // 对响应数据做点什么，允许在数据返回客户端前，修改响应的数据
//   // 如果只需要返回体中数据，则如下，如果需要全部，则 return response 即可
//   if (response && response.data && response.data.code === 401) {
//     // var that = this;
//     // this.$warning({
//     //   title: '登录失效',
//     //   content: "您当前未登录，请先登录",
//     //   onOk(){
//     //     that.$router.push('/login');
//     //   }
//     // });
//     // this.$router.push('/login');
//
//     //20200410 完善登录过期自动跳转登录页
//     // localStorage.removeItem("token");
//     // localStorage.removeItem("refreshToken");
//     // if (isMobile()){
//     //   router.push('/mlogin');
//     // } else {
//     //   router.push('/login');
//     // }
//   }
//   return response.data
// }, function (error) {
//   // 对响应错误做点什么
//   return Promise.reject(error)
// })

// 封装数据返回失败提示函数---------------------------------------------------------------------------
function errorState (response) {
  // 隐藏loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return response
  } else {
    // alert('数据获取错误')
  }
}

// 封装数据返回成功提示函数---------------------------------------------------------------------------
function successState (res) {
  // 隐藏loading
  // 统一判断后端返回的错误码(错误码与后台协商而定)
  if (res.code === 0) {

    // alert('success')
    return res
  }
}

// 封装axios--------------------------------------------------------------------------------------
function apiAxios (method, url, params) {
  let httpDefault = {
    method: method,
    baseURL: Vue.prototype.$baseURL,//调用common.js的baseURL的公共参数
    url: url,
    // `params` 是即将与请求一起发送的 URL 参数
    // `data` 是作为请求主体被发送的数据
    params: method === 'GET' || method === 'DELETE' ? params : null,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
    timeout: 60000
  }

  // 注意**Promise**使用(Promise首字母大写)
  return new Promise((resolve, reject) => {
    axios(httpDefault)
    // 此处的.then属于axios
      .then((res) => {
        successState(res)
        resolve(res)
      }).catch((response) => {
      errorState(response)
      reject(response)
    })
  })
}

// 输出函数getAxios、postAxios、putAxios、delectAxios，供其他文件调用-----------------------------
// Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
export default {
  install: function (Vue) {
    Vue.prototype.getAxios = (url, params) => apiAxios('GET', url, params)
    Vue.prototype.postAxios = (url, params) => apiAxios('POST', url, params)
    Vue.prototype.putAxios = (url, params) => apiAxios('PUT', url, params)
    Vue.prototype.delectAxios = (url, params) => apiAxios('DELECT', url, params)
  }
}



// WEBPACK FOOTER //
// ./src/assets/api/request.js